import { Controller } from "@hotwired/stimulus"

// Controls dynamic trigger and action configuration sections in the automation form.
// Shows/hides config partials based on the selected trigger type and action type.
export default class extends Controller {
  static targets = ["triggerConfig", "actionConfig"]

  declare readonly triggerConfigTarget: HTMLElement
  declare readonly actionConfigTarget: HTMLElement

  connect(): void {
    this.showMatchingSection(this.triggerConfigTarget, "triggerType")
    this.showMatchingSection(this.actionConfigTarget, "actionType")
  }

  triggerTypeChanged(event: Event): void {
    this.showMatchingSection(this.triggerConfigTarget, "triggerType")
  }

  actionTypeChanged(event: Event): void {
    this.showMatchingSection(this.actionConfigTarget, "actionType")
  }

  private showMatchingSection(container: HTMLElement, dataAttr: string): void {
    const select = this.element.querySelector(
      `[data-action*="automation-form#${dataAttr}Changed"]`
    ) as HTMLSelectElement | null

    const selectedValue = select?.value || ""
    const sections = container.querySelectorAll<HTMLElement>(`[data-${this.dasherize(dataAttr)}]`)

    sections.forEach((section) => {
      const sectionType = section.getAttribute(`data-${this.dasherize(dataAttr)}`)
      if (sectionType === selectedValue && selectedValue !== "") {
        section.style.display = ""
      } else {
        section.style.display = "none"
        // Clear inputs in hidden sections to avoid stale data
        if (sectionType !== selectedValue) {
          this.clearInputs(section)
        }
      }
    })
  }

  private clearInputs(container: HTMLElement): void {
    const inputs = container.querySelectorAll<HTMLInputElement | HTMLSelectElement>(
      "input[type='checkbox'], select"
    )

    inputs.forEach((input) => {
      if (input.type === "checkbox") {
        ;(input as HTMLInputElement).checked = false
      } else if (input.tagName === "SELECT") {
        ;(input as HTMLSelectElement).selectedIndex = 0
      }
    })
  }

  private dasherize(str: string): string {
    return str.replace(/([A-Z])/g, "-$1").toLowerCase().replace(/^-/, "")
  }
}
